export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Suppliers.vue?vue&type=template&id=a0f4c6ba"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Suppliers.vue?vue&type=template&id=a0f4c6ba
// module id = 145
// module chunks = 0